import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const CODIGO_FCI_REGEX = /^[A-F0-9]{8}-[A-F0-9]{4}-[A-F0-9]{4}-[A-F0-9]{4}-[A-F0-9]{12}$/;

// Código FCI é opcional — só valida o formato (padrão nFCI 8-4-4-4-12) quando preenchido.
export function codigoFciValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = (control.value || '').trim();
    if (!value) return null;
    return CODIGO_FCI_REGEX.test(value) ? null : { codigoFciInvalido: true };
  };
}
